import { render, staticRenderFns } from "./IconTwitter.vue?vue&type=template&id=5a786524&scoped=true&"
var script = {}
import style0 from "./IconTwitter.vue?vue&type=style&index=0&id=5a786524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a786524",
  null
  
)

export default component.exports